import { render } from "./index.vue?vue&type=template&id=3416692c"
import script from "./leagues.ts?vue&type=script&lang=js"
export * from "./leagues.ts?vue&type=script&lang=js"

import "./leagues.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script